import React from 'react';
import styled from 'styled-components';
import Required from '../../atoms/Required';

export const Row = styled.div`
  display: flex;
  margin: 8px 0;
  padding: 8px 0;
  border-bottom: 1px solid #eee;
`;

export const RowHeader = styled.div`
  width: 25%;
`;

export const RowCell = styled.div`
  width: 75%;
`;

export const PartnerClientHeaders = ({ keyName }) => {
  const headers = {
    id: <RowHeader>PartnerClient ID</RowHeader>,
    name: (
      <RowHeader>
        PartnerClient名 <Required />
      </RowHeader>
    ),
    client_secret: <RowHeader>Client Secret</RowHeader>,
    organization: (
      <RowHeader>
        組織 <Required />
      </RowHeader>
    ),
    admin_user: (
      <RowHeader>
        管理ユーザ <Required />
      </RowHeader>
    ),
    organization_and_user: (
      <RowHeader>
        組織+管理ユーザ <Required />
      </RowHeader>
    ),
    description: <RowHeader>説明</RowHeader>,
    status: <RowHeader>状態</RowHeader>,
  };
  return headers[keyName];
};

export default PartnerClientHeaders;
